/**
 * 重写日志 （主要是避免打包时被删除日志）
 * ！！！ 重要的日志不被清理
 */

import { isBuild } from '@/jmHttp/host';
import { isElectron } from '@/utils/electron';
import electronLogger from './electron-log';
import slsLogger from './slsLogger';

function getTimestamp() {
  const now = new Date();
  return now.toISOString().replace('T', ' ').substring(0, 19);
}

function formatPrefix(level) {
  return `[${level.toUpperCase()}:${getTimestamp()}]`;
}

/**
 * 仅用于 sls 文本：避免 Array.prototype.join 对对象做隐式 ToString 导致抛错（如 Vue Proxy）
 * @example TypeError: Cannot convert object to primitive value
 * @param {any} arg - 日志参数
 * @returns {string} 格式化后的日志参数
 */
function formatLogArg(arg) {
  if (arg === null) return 'null';
  if (typeof arg === 'undefined') return 'undefined';
  const t = typeof arg;
  if (t === 'string' || t === 'number' || t === 'boolean') return String(arg);
  if (t === 'bigint') return String(arg);
  if (t === 'symbol') {
    try {
      return String(arg);
    } catch {
      return '[Symbol]';
    }
  }
  if (t === 'function') return '[Function]';
  try {
    const s = JSON.stringify(arg);
    return typeof s === 'string' ? s : '[Object]';
  } catch {
    return '[Object]';
  }
}

function safeLog(method, ...args) {
  if (['info', 'log', 'warn', 'error'].includes(method)) {
    slsLogger.console({
      message: args.map(formatLogArg).join(' ')
    });
  }

  Function.prototype.apply.call(console[method], console, args);

  if (isElectron) {
    electronLogger.log(method, ...args);
  }
}

const Logger = {};
const skipPrefix = ['group', 'groupCollapsed', 'groupEnd', 'time', 'timeEnd'];
const devOnly = ['debug'];

Object.getOwnPropertyNames(console).forEach((method) => {
  if (typeof console[method] !== 'function') return;

  Logger[method] = function (...args) {
    if (devOnly.includes(method) && isBuild) return;

    const prefix = skipPrefix.includes(method) ? '' : formatPrefix(method);

    safeLog(method, prefix, args);
  };
});

export default Logger;
